module.exports = __webpack_public_path__ + "static/media/7.771cad45.jpg";